import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const TopBar = ({ user }) => {
  const [userInfoId, setUserInfoId] = useState('');
  const [nickname, setNickname] = useState('');

  useEffect(() => {
    // localStorage에서 userInfoId와 nickname 가져오기
    const storedUserInfoId = localStorage.getItem('userInfoId');
    const storedNickname = localStorage.getItem('nickname');
    
    console.log('TopBar 로드 - localStorage:', { storedUserInfoId, storedNickname });
    
    if (storedUserInfoId) {
      setUserInfoId(storedUserInfoId);
    }
    if (storedNickname) {
      setNickname(storedNickname);
    }
  }, [user]);

  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      // localStorage 초기화
      localStorage.removeItem('isAdmin');
      localStorage.removeItem('userId');
      localStorage.removeItem('userInfoId');
      localStorage.removeItem('nickname');
      window.location.href = '/login'; // Redirect to login page after logout
    } catch (error) {
      alert(error.error_description || error.message);
    }
  };

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

      <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
      </button>

      <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
          <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2" />
          <div className="input-group-append">
            <button className="btn btn-primary" type="button">
              <i className="fas fa-search fa-sm"></i>
            </button>
          </div>
        </div>
      </form>

      <ul className="navbar-nav ml-auto">

        <div className="topbar-divider d-none d-sm-block"></div>

        <li className="nav-item">
          <span className="mr-3 d-none d-lg-inline text-gray-600 small">안녕하세요 {nickname || userInfoId} 님</span>
        </li>

        <li className="nav-item">
          <button className="btn btn-sm btn-logout" onClick={handleLogout} style={{ backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', padding: '8px 16px', cursor: 'pointer' }}>
            <i className="fas fa-sign-out-alt mr-2"></i>
            Logout
          </button>
        </li>

      </ul>

    </nav>
  );
};

export default TopBar;